import { z } from 'zod';

export const schema = z.object({
  email: z
    .string()
    .min(1, { message: 'required' })
    .pipe(z.email({ message: 'notValid' })),
});

export type FormEmail = z.infer<typeof schema>;
